import { WorkOsWidgets } from '@workos-inc/widgets';
import type { ReactNode } from 'react';

// WorkOS widgets render Radix primitives internally and depend on the
// Radix Themes token CSS being loaded somewhere. The widgets' own
// styles.css only ships widget-specific rules (cards, animations) —
// it does NOT include the Radix token vars. Both imports are required.
// Order matters: Radix tokens first, widget rules layered on top.
import '@radix-ui/themes/styles.css';
import '@workos-inc/widgets/styles.css';

/**
 * Wraps children with the WorkOS Widgets context (auth + react-query
 * data fetching for widgets), and locks the Radix Theme wrapper to
 * light. The rest of the app is light-only (see styles.css), so
 * following prefers-color-scheme would make the Radix wrapper paint a
 * dark background on top of the light body.
 */
export function WidgetsProvider({ children }: { children: ReactNode }) {
  return (
    <WorkOsWidgets theme={{ appearance: 'light', accentColor: 'indigo' }}>
      {children}
    </WorkOsWidgets>
  );
}
